export const all_routes = {
  //   adminDashboard: "/admin-dashboard",
  //   employeeDashboard: "/employee-dashboard",
  //   leadsDashboard: "/leads-dashboard",
  //   dealsDashboard: "/deals-dashboard",
  adminDashboard: "/super-admin-dashboard",
  dashboardItems: "/dashboard-items",

  googleMap: "/google-map",

  // ======== Nestfin Superadmin ========
  organization: "/organization",
  property: "/property",
  subscription: "/subscription",
  collection: "/collection",
  perOrganization: "/per-organization",
  reconciliation: "/reconciliation",
  transactionReport: "/transaction-report",
  transectionDashboardItems: "/reconciliation-dashboard-items",

  AllOrganizations: "/organization-list",
  inventoryList: "/property-real-time-inventory",
  // inventoryList: "/real-time-inventory",
  editOrganization: "/edit-organization",
  tenants: "/tenant-list",
  tenantsDetails: "/view-tenant-details",
  bookings: "/booking-list",

  AllProperty: "/property-list",
  EditProperty: "/property-list-edit",
  viewPropertyImages: "/view-property-gallery",
  propertyLeads: "/property-leads",

  complaints: "/complaints-list",
  complainDetails: "/view-complaint-details/:id",
  expenses: "/expenses-list",

  allBanks: "/bank-list",
  collectionReport: "/collection-report",
  staffTransaction: "/staff-transaction",
  bankTransaction: "/bank-transaction",

  uploadLeads: "/upload-leads",
  leadsList: "/leads-list",
  leadsReport: "/leads-report",
  leadsManagement: "/leads-management",

  paidCollection: "/paid-collection",
  unPaidCollection: "/unpaid-collection",
  dashboard:"/dashboard-items",
  subscriptionExpired: "/expired-subscription",
  subscriptionActive: "/active-subscription",
  subscriptionNew: "/new-subscription",

  // ======== end Nestfin Superadmin ========

  // auth routes routes
  login: "/login",
  register: "/register",
  forgotPassword: "/forgot-password",
  twoStepVerification: "/two-step-verification",
  success: "/success",
  emailVerification: "/email-verification",
  lockScreen: "/lock-screen",
  resetPassword: "/reset-password",
  resetPasswordSuccess: "/success",
  error404: "/error-404",
  error500: "/error-500",
  errorTimeout: "/error-timeout",
  invoicePayment: "/payment/:token",
  invoicePaymentAlias: "/pay/:token",
};
